<div class="input__container">
    <div class="wrap__input" [ngClass]="[
        isValid || control.disabled ? 'valid__input' : 'invalid__input',
        control.disabled ? 'disable' : 'enable'
    ]">
        <input
            placeholder="0812121212"
            maxlength="13" 
            numberOnly
            [formControl]="control"
            (input)="onInput($event)"
        />
        @if (isShowResetInput() && control.value) {
        <button (click)="onClickResetInput()">
            <img src="assets/icons/close.svg" alt="reset icon" />
        </button>
        }
    </div>
        <!-- ERROR MESSAGE INPUT -->
    @if (control.errors) {
    <div class="message__input">{{ control.errors | errorMessage | translate }}</div>
    }
</div>  